window.Products.Clothing.ClassicPulloverHoodie = function() {
};
window.Products.Clothing.ClassicPulloverHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ClassicPulloverHoodie.dpi = 150;
window.Products.Clothing.ClassicPulloverHoodie.has_3d = true;
window.Products.Clothing.ClassicPulloverHoodie.id = 113;
window.Products.Clothing.ClassicPulloverHoodie.slug = 'classic-pullover-hoodie';
window.Products.Clothing.ClassicPulloverHoodie.syncColors = true;
window.Products.Clothing.ClassicPulloverHoodie.texturesLoaded = 0;
window.Products.Clothing.ClassicPulloverHoodie.texturesLoading = false;
window.Products.Clothing.ClassicPulloverHoodie.use_glb = true;

window.Products.Clothing.ClassicPulloverHoodie.prototype.outsideObject = 0;
window.Products.Clothing.ClassicPulloverHoodie.prototype.detailsObject = 1;
window.Products.Clothing.ClassicPulloverHoodie.prototype.position = 0.1;

window.Products.Clothing.ClassicPulloverHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.ClassicPulloverHoodie.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"cardinal_red": 0x732137,
		"dark_heather": 0x4f5255,
		"charcoal": 0x504f53,
		"dark_chocolate": 0x3d3532,
		"gold": 0xc4830d,
		"royal": 0x2e4990,
		"heliconia": 0xa92660,
		"navy": 0x2c2f40,
		"sand": 0xa69f8d,
		"sport_grey": 0x909090,
	};

	return new THREE.Color(colors[_name]);
};